const CONTACT_GREEN = '#519003';

const markerIcon = (L) => L.divIcon({
    className: 'led-contact-map-marker-wrap',
    html: `<span class="led-contact-map-marker" style="--led-map-marker:${CONTACT_GREEN}" aria-hidden="true"></span>`,
    iconSize: [30, 30],
    iconAnchor: [15, 15],
});

export function initContactMap() {
    const root = document.querySelector('[data-contact-map]');
    const host = root?.querySelector('[data-contact-map-canvas]');
    const L = window.L || null;
    if (!root || !host || !L || root.dataset.contactMapReady === '1') return null;

    const lat = Number(root.dataset.lat);
    const lng = Number(root.dataset.lng);
    const zoom = Number(root.dataset.zoom || 15);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

    const map = L.map(host, {
        zoomControl: false,
        attributionControl: true,
        preferCanvas: true,
        scrollWheelZoom: false,
        dragging: true,
        tap: true,
    });

    L.control.zoom({ position: 'bottomright' }).addTo(map);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(map);

    L.marker([lat, lng], { icon: markerIcon(L), title: root.dataset.label || 'LED Architects' }).addTo(map);
    map.setView([lat, lng], Number.isFinite(zoom) ? zoom : 15);

    root.dataset.contactMapReady = '1';
    const refresh = () => window.setTimeout(() => map.invalidateSize({ animate: false }), 30);
    window.addEventListener('resize', refresh, { passive: true });
    window.requestAnimationFrame(refresh);

    return { map, refresh };
}
